/* Drawer Cart JS */
/**
 * Get reference to the mini-cart, mini-cart__trigger and overlay DOM
 * elements.
 */
const miniCart = document.querySelector(".mini-cart");
const miniCartTrigger = document.querySelector(".site-header__cart");
const overlay = document.querySelector(".overlay");
const atc = document.querySelector(".product-form__cart-submit");
const miniCartClose = document.querySelector(".cart__close");

/**
 * When the user clicks the mini-cart__trigger element add classes to the
 * overlay and mini-cart elements to show them.
 */
miniCartTrigger.addEventListener("click", (e) => {
  e.preventDefault();

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      renderCart(cartData);
      overlay.classList.add("overlay--show");
      miniCart.classList.add("mini-cart--show");
    })
    .catch((err) => console.error("Cart update failed:", err));
});

/**
 * Handle cart open on Add to Cart Click Button
 */

atc.addEventListener("click", (e) => {
  e.preventDefault();

  const form = atc.closest("form");
  const formData = new FormData(form);

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(formData).toString(),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status && data.status !== 200) {
        console.error("Error adding to cart:", data);
        return;
      }

      setTimeout(() => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            renderCart(cartData);
            overlay.classList.add("overlay--show");
            miniCart.classList.add("mini-cart--show");
          })
          .catch((err) => console.error("Cart update failed:", err));
      }, 800);
    })
    .catch((err) => console.error("Cart update failed:", err));
});

/**
 * When the user clicks the overlay element remove classes from the mini-cart
 * and overlay to hide them again.
 */

overlay.addEventListener("click", () => {
  console.log("clicked");
  overlay.classList.remove("overlay--show");
  miniCart.classList.remove("mini-cart--show");
});

/**
 * When the user clicks the close mini cart button remove classes from the mini-cart.
 */

miniCartClose.addEventListener("click", () => {
  console.log("clicked");
  overlay.classList.remove("overlay--show");
  miniCart.classList.remove("mini-cart--show");
});

/**
 * Sends a GET request to the '/{locale}/cart.js' route of the Shopify Ajax
 * API, returns the response as JSON and then passes the data to the
 * renderCart function, which outputs the content.
 */
fetch(window.Shopify.routes.root + "cart.js")
  .then((response) => response.json())
  .then((data) => {
    // Loop through items and attach them to the DOM
    renderCart(data);
  })
  .catch((err) => console.log(err));

// Shop Pay Label Dom Update

/**
 * Outputs cart items and content in the DOM.
 */
function renderCart(data) {
  // Get DOM element where the cart items will be attached
  const miniCartItems = document.querySelector(".mini-cart__items");
  const subtotalPrice = document.querySelector(".subtotal-price");
  const totalCartItems = document.querySelector(".total__cart__items");
  const miniCartSummary = document.querySelector(".mini-cart__summary");
  const checkoutButton = document.querySelector(".cart__checkout");
  const productSlider = document.querySelector(".product-slider");
  const miniCartSlider = document.querySelector("#mini-cart-carousel");
  const miniCartSliderHeading = document.querySelector(".product-slider-heading");
  const miniCartCheckboxContainer = document.querySelector(".mini-cart-checkbox-container");
  const miniCartCheckbox = document.querySelector("#b2b_checkbox"); // B2B Checkbox
  const b2bInputBox = document.querySelector(".b2b_input_box");
  const cartCount = document.querySelector("#CartCount span");
  const cartCountContainer = document.querySelector("#CartCount");

  // Clear HTML in the mini cart items
  if (miniCartItems) miniCartItems.innerHTML = "";

  // Loop through cart items and attach them to the mini-cart__items element
  if (data.items.length > 0) {
    let subtotal = 0;
    let totalSavings = 0;
    let total = 0;
    let totalItems = 0;

    data.items.forEach((item) => {
      //console.log("ITEM - ", item);
      const originalPrice = item.original_price * item.quantity;
      const discountedPrice = item.final_line_price;
      const savings = originalPrice - discountedPrice;

      const size = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "size"
      )?.value;
      const color = item.options_with_values.find(
        (opt) =>
          opt.name.toLowerCase() === "color" ||
          opt.name.toLowerCase() === "colour"
      )?.value;
      const width = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "width"
      )?.value;
      let sizeAndColor = [size, color, width].filter(Boolean).join(" | ");

      subtotal += originalPrice;
      totalSavings += savings;
      total += discountedPrice;
      totalItems += item.quantity;

      miniCartItems.innerHTML += `
                <div class="mini-cart__item" data-line-key="${item.key}">
<img src="${item.featured_image.url}" alt="${
        item.featured_image.alt
      }" class="item__image" />
<div class="item__info">
   <h3 class="product-title">${item.vendor}</h3>
   <p class="product-name"><a href="${item.url}">${item.product_title}</a></p>
   <p class="product-size"> ${sizeAndColor}
   </p>
   <div class="price__and__quantity">
    <div class="item__actions">
         <div class="quantity-input">
            <button type="button" class="minus">-</button>
            <input type="hidden" class="item__line-key" value="${item.key}" />
            <input type="text" class="item__quantity" min="1" value="${
              item.quantity
            }" />
            <button type="button" class="plus">+</button>
         </div>
         <button class="item__remove" data-line-key="${
           item.key
         }"><img width="32" height="32" src="https://img.icons8.com/windows/32/trash.png" alt="trash"/></button>
      </div>
      <div>
         <p class="product-price">
            <span class="discounted-price">$${(
              item.discounted_price / 100
            ).toFixed(2)}</span>
         </p>
      </div>
   </div>
  <div class="error-message"></div>
</div>
</div>
            `;

      // Update values
      if (subtotalPrice)
        subtotalPrice.textContent = `$${(subtotal / 100).toFixed(2)}`;
      if (totalCartItems) {
        totalCartItems.textContent =
          totalItems > 1
            ? `SHOPPING CART (${totalItems} ITEMS)`
            : `SHOPPING CART (${totalItems} ITEM)`;
      }
      console.log(cartCount, cartCount.textContent);

      if (cartCount) {
        cartCount.textContent = totalItems;
        cartCountContainer.style.display = "block";
      }

      // Handle B2B checkbox logic
      if (miniCartCheckboxContainer) {
        miniCartCheckboxContainer.style.display =
          totalItems >= window.b2bProgramThresholdQty ? "block" : "none";
        if (totalItems >= window.b2bProgramThresholdQty) {
          // Reset checkbox to unchecked when items reach threshold qty
          localStorage.setItem("b2bCheckboxValue", "no");
          miniCartCheckbox && (miniCartCheckbox.checked = false);
        }

        // Retrieve stored value from localStorage and apply it to the checkbox
        const storedValue = localStorage.getItem("b2bCheckboxValue");
        miniCartCheckbox && (miniCartCheckbox.checked = storedValue === "yes");

        // Show/hide b2bInputBox based on stored value (only if it exists)
        b2bInputBox?.style &&
          (b2bInputBox.style.display =
            storedValue === "yes" ? "block" : "none");

        // Update localStorage and UI when checkbox changes
        miniCartCheckbox?.addEventListener("change", function () {
          const isChecked = this.checked ? "yes" : "no";
          localStorage.setItem("b2bCheckboxValue", isChecked);
          console.log("Stored in localStorage:", isChecked);

          // Toggle b2bInputBox visibility
          b2bInputBox?.style &&
            (b2bInputBox.style.display = this.checked ? "block" : "none");
        });

        // Remove hidden input if totalItems < threshold qty
        if (totalItems < window.b2bProgramThresholdQty) {
          document.querySelector(".b2b_input_box")?.remove();
        }
      } else {
        console.error(
          "miniCartCheckboxContainer not found! Check if #b2b_checkbox_container exists."
        );
      }

      // Show mini-cart summary and checkout button
      [
        miniCartSummary,
        checkoutButton,
        productSlider,
        miniCartSlider,
        miniCartSliderHeading,
      ].forEach((el) => {
        if (el) el.style.display = "block";
      });
    });
  } else {
    miniCartItems.innerHTML =
      '<div class="mini-cart__empty"><img src="https://www.bhfo.com/cdn/shop/t/82/assets/logo-white.svg?v=155328063350091759861725015479" alt="logo" /><p>You have no items in your cart</p><a href="/"><button class="mini-cart__empty__button">Continue Shopping</button></a></div>';
    if (subtotalPrice) subtotalPrice.textContent = "$0.00";
    if (totalCartItems) totalCartItems.textContent = `YOUR CART`;
    const storedValue = localStorage?.getItem("b2bCheckboxValue");
    const b2bInputBox = document.querySelector(".b2b_input_box");

    if (cartCount) {
      cartCount.textContent = "0";
      cartCountContainer.style.display = "block";
    }

    if (storedValue == "no" && b2bInputBox) {
      b2bInputBox.style.display = "none";
    }
    // Hide mini-cart summary and checkout button
    [
      miniCartSummary,
      checkoutButton,
      productSlider,
      miniCartSlider,
      miniCartSliderHeading,
      miniCartCheckbox,
    ].forEach((el) => {
      if (el) el.style.display = "none";
    });
  }

  if (typeof handleQuantityInputs === "function") handleQuantityInputs();
  if (typeof handleRemoveItem === "function") handleRemoveItem();
}

/**
 * Attaches event listeners to the quantity input buttons, and
 * updates the value of the quantity input field.
 */
function handleQuantityInputs() {
  // Get a refernce to any quantity inputs
  const qtyInputEls = document.querySelectorAll(".mini-cart .quantity-input");

  // If there are any then loop through them and attach event listeners
  if (qtyInputEls.length > 0) {
    qtyInputEls.forEach((input) => {
      let plusBtn = input.querySelector(".plus");
      let minusBtn = input.querySelector(".minus");
      let qtyInput = input.querySelector(".item__quantity");
      let lineKey = input.querySelector(".item__line-key").value;

      // Store previous valid quantity in a data attribute
      qtyInput.setAttribute("data-prev-value", qtyInput.value);

      // Increase the quantity input value
      plusBtn.addEventListener("click", () => {
        let newQty = parseInt(qtyInput.value) + 1;
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });

      // Decrease the quantity input value, making sure it doesn't go below 1
      minusBtn.addEventListener("click", () => {
        let newQty = Math.max(1, parseInt(qtyInput.value) - 1); // Prevent going below 1
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });
    });
  }
}

/**
 * Sends a request to the Ajax API to update the quantity of the line item.
 */

function updateItemQuantity(lineKey, value, qtyInput) {
  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: parseInt(value),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data?.status === 422) {
        const miniCartItem = document.querySelector(
          `.mini-cart__item[data-line-key="${lineKey}"]`
        );
        let errorMsg = miniCartItem.querySelector(".error-message");

        errorMsg.textContent = data.message;

        qtyInput.value = qtyInput.getAttribute("data-prev-value");
        return;
      }

      document
        .querySelectorAll(".error-message")
        .forEach((msg) => msg.remove());

      renderCart(data);
    })
    .catch((error) => console.error("Cart update failed:", error));
}

/**
 * Sends a request to the Ajax api, updating the selected items quantity
 * to 0, which will remove it from the cart.
 */

function handleRemoveItem(lineKey, value) {
  const removeItemButton = document.querySelectorAll(".item__remove");

  removeItemButton.forEach((button) => {
    // Get the line item key from the buttons data attribute
    let lineKey = button.dataset.lineKey;

    button.addEventListener("click", () => {
      // Update the item quantity to 0 in the cart to remove it
      updateItemQuantity(lineKey, 0);
    });
  });
}

/**
 * Handle removing all cart items
 */
const removeAllButton = document.querySelector(".mini-cart__remove-all");
removeAllButton.addEventListener("click", () => {
  fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "post",
  })
    .then((response) => response.json())
    .then((data) => {
      renderCart(data);
    });
});
